import { Link } from "react-router-dom";
import { TasksIcon } from "../../components/ui/Icons";
import { Page } from "../../components/ui/Page";
import { usePanelPath } from "../../routing";

export function ScreenoutPage() {
  const panelPath = usePanelPath();
  return (
    <Page>
      <div className="completion-wrap">
        <div className="screenout-icon">
          <TasksIcon />
        </div>
        <h2
          style={{
            color: "var(--primary)",
            fontFamily: "var(--font-h)",
            fontSize: 26,
            fontWeight: 600,
          }}
        >
          Not a match this time
        </h2>
        <p
          style={{
            color: "var(--sand)",
            fontSize: 14,
            lineHeight: 1.6,
            margin: "8px 0 22px",
          }}
        >
          This survey was looking for a specific profile that didn't match yours
          right now — that's completely normal. More tasks will come through.
        </p>
        <div className="alert alert-info" style={{ textAlign: "left" }}>
          <strong>Tip</strong> Having a completed profile means you're more
          likely to get accepted for tasks.{" "}
          <a href={panelPath("/profile/edit")}>Update your profile now!</a>
        </div>
        <Link
          className="btn btn-accent btn-full"
          style={{ marginBottom: 10 }}
          to={panelPath("/tasks")}
        >
          View other tasks
        </Link>
        <Link className="btn btn-outline btn-full" to={panelPath("/")}>
          Back to dashboard
        </Link>
      </div>
    </Page>
  );
}
